// extracted by mini-css-extract-plugin
export default {"container":"share_container__JIXCC","title":"share_title__COkBo","arrow":"share_arrow__WkSs+"};